import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type CoreOutboxEventCountsResult = QueryAtomResult<
  typeof coreOutboxEventCountsQueryAtom
>;

export const coreOutboxEventCountsQueryAtom = createQueryAtomFactory(
  'auditLog.coreOutboxEventCounts',
  () => ({
    coreOutboxEventCounts: {
      organization: true,
      user: true,
      facility: true,
      facilityGroup: true,
    },
  }),
  {
    select: ({ coreOutboxEventCounts }) => coreOutboxEventCounts,
  },
);
